import React from 'react';

const base = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
};

const Svg = ({ className = 'w-6 h-6', children, ...props }) => (
  <svg className={className} viewBox="0 0 24 24" {...base} {...props}>
    {children}
  </svg>
);

export const ArrowLeft = ({ className = 'w-6 h-6', ...props }) => (
  <Svg className={className} {...props}>
    <path d="M19 12H6" />
    <path d="M12 18l-6-6 6-6" />
  </Svg>
);

export const X = ({ className = 'w-6 h-6', ...props }) => (
  <Svg className={className} {...props}>
    <path d="M18 6L6 18" />
    <path d="M6 6l12 12" />
  </Svg>
);

export const Check = ({ className = 'w-6 h-6', ...props }) => (
  <Svg className={className} {...props}>
    <path d="M20 6L9 17l-5-5" />
  </Svg>
);

export const CheckCheck = ({ className = 'w-6 h-6', ...props }) => (
  <Svg className={className} {...props}>
    <path d="M20 6L9 17l-5-5" />
    <path d="M22 8l-6.5 7" opacity="0.7" />
  </Svg>
);
